// Auto-load every locale message file present in ./locales. Dropping a new
// <code>.json into that folder is picked up automatically — no edit here and
// no edit to index.ts. The active locale SET is defined by `activeTier` in
// src/config/locales.json; the verify scripts keep "files present" in sync with
// "tier active" so we never ship a file for an inactive locale (or vice versa).
//
// Eager for now (matches the previous static-import behavior: no boot flash).
// BLOCKING PREREQUISITE FOR activeTier=2 (Astro, 44 locales): switch to lazy
// `import()` + on-demand setLocaleMessage (keeping only `en` eager as fallback)
// before activating tier 2 — otherwise the eager glob adds ~1.6MB of locale
// JSON to the critical-path index chunk for every user. At tier 1 (16 locales,
// ~250KB) it is acceptable.
import en from './locales/en.json'

// Message schema is the shape of the English bag (the source of truth / fallback).
export type MessageSchema = typeof en

const modules = import.meta.glob('./locales/*.json', { eager: true }) as Record<
    string,
    { default: MessageSchema }
>

export const messages: Record<string, MessageSchema> = {}
for (const path in modules) {
    const m = path.match(/\/([^/]+)\.json$/)
    if (!m) continue
    const code = m[1]
    if (code.startsWith('uni-app')) continue // skip non-UI bundles, mirrors sync-locales.mjs
    messages[code] = modules[path].default
}

